import global from '@/assets/js/global'
import axios from 'axios'

const path = 'firestoreForm2'
const advancePath = 'firestoreForm2/advance'
const manualBillPath = 'firestoreForm2/billPayment'

/*
 *  FORM
 */

const get = async (params, token) => {
  const options = {
    params,
    headers: { authorization: token },
  }
  const res = await axios.get(`${global.server}${path}`, options)
  const form = res.data

  if (form.school && typeof form.school === 'object') {
    form.schoolLevel = form.school.level
    form.school = form.school.name
  } else if (typeof form.school === 'string') {
    form.schoolLevel = null
  }
  return form
}

const put = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.put(`${global.server}${path}`, body, options)
  return res.data
}

// 刪除
const remove = async (data, token) => {
  const options = {
    headers: { authorization: token },
    data,
  }
  const res = await axios.delete(`${global.server}${path}`, options)
  return res.data
}

// 晉級
const advance = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.post(`${global.server}${advancePath}`, body, options)
  return res.data
}

// 手動設為已繳費
const manualBill = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.post(`${global.server}${manualBillPath}`, body, options)
  return res.data
}

export default {
  get,
  put,
  remove,
  advance,
  manualBill,
}
